export const translations = {
  fi: {
    nav: {
      home: "Etusivu",
      shop: "Kauppa",
      story: "Tarina",
      cart: "Kori",
      admin: "Ylläpito",
    },
    hero: {
      eyebrow: "Käsintehtyjä pikkuruisuuksia",
      title: "Pieniä\naarteita\nkäsin tehden.",
      lede: "Rakkaudella muotoiltuja keramiikan pikkurumiluksia — jokainen pieni, kummallinen ja aivan omansa.",
      cta_shop: "Katso mallistoa",
      cta_story: "Studion tarina",
    },
    shop: {
      title: "Mallisto",
      subtitle: "Käsityönä valmistetut kappaleet, jokainen ainutlaatuinen.",
      view: "Katso",
      add: "Lisää koriin",
      added: "Lisätty koriin",
      stock: "kpl varastossa",
      outOfStock: "Loppu varastosta",
    },
    product: {
      details: "Tuotetiedot",
      back: "← Takaisin mallistoon",
      quantity: "Määrä",
      noteLabel: "Lisätietoja",
      handmade: "Käsintehty • polttoja pienissä erissä",
      care: "Hoito: käsinpesu suositeltavaa",
    },
    cart: {
      title: "Ostoskori",
      empty: "Korisi on tyhjä.",
      browse: "Selaa mallistoa",
      subtotal: "Välisumma",
      shipping: "Toimituskulut lasketaan seuraavassa vaiheessa.",
      checkout: "Siirry maksamaan",
      remove: "Poista",
      each: "kpl",
    },
    payment: {
      success_title: "Kiitos tilauksestasi",
      success_body: "Vahvistuksesi on lähetetty sähköpostiisi. Käsittelemme tilauksesi pian.",
      cancel_title: "Maksu keskeytettiin",
      cancel_body: "Tilaustasi ei ole veloitettu. Voit palata koriin ja yrittää uudelleen.",
      continue: "Jatka selailua",
      verifying: "Vahvistetaan maksua…",
    },
    admin: {
      login: "Kirjaudu ylläpitoon",
      email: "Sähköposti",
      password: "Salasana",
      signIn: "Kirjaudu",
      dashboard: "Ylläpito",
      products: "Tuotteet",
      orders: "Tilaukset",
      add_product: "Lisää tuote",
      edit: "Muokkaa",
      delete: "Poista",
      save: "Tallenna",
      cancel: "Peruuta",
      logout: "Kirjaudu ulos",
      name_fi: "Nimi (FI)",
      name_en: "Nimi (EN)",
      name_sv: "Nimi (SV)",
      desc_fi: "Kuvaus (FI)",
      desc_en: "Kuvaus (EN)",
      desc_sv: "Kuvaus (SV)",
      price: "Hinta (€)",
      image_url: "Kuvan URL",
      stock: "Varasto",
      featured: "Nostettu etusivulle",
      confirm_delete: "Haluatko varmasti poistaa?",
    },
    footer: {
      studio: "Studio",
      contact: "Yhteystiedot",
      address: "Ateljee — Turun saaristo, Suomi",
      rights: "Kaikki oikeudet pidätetään.",
    },
    story: {
      title: "Käsi, savi, tuli.",
      body: "Jokainen kappale syntyy hitaasti. Käytämme paikallista savea, ja poltamme uunimme pienissä erissä — joten värit ja pinnat vaihtelevat, kuten luonnossakin. Näet studion sormenjäljet jokaisessa kupissa.",
    },
    showcase: {
      eyebrow: "Kokoelmasta",
      title: "Pieniä sydämiä,\nhiljaisia kaneja.",
      body: "Kupit ja veistokset, jotka kutsuvat lähelle.",
    },
    instagram: {
      eyebrow: "Instagramissa",
      title: "Seuraa @pikkurumiluksia",
      follow: "Seuraa Instagramissa",
      empty: "Postauksia ei ole vielä lisätty.",
    },
  },
  en: {
    nav: {
      home: "Home",
      shop: "Shop",
      story: "Story",
      cart: "Cart",
      admin: "Admin",
    },
    hero: {
      eyebrow: "Handmade little treasures",
      title: "Tiny\ntreasures,\nhand-made.",
      lede: "Ceramic little curiosities shaped with love — each one small, quirky and entirely its own.",
      cta_shop: "Explore the collection",
      cta_story: "Studio story",
    },
    shop: {
      title: "Collection",
      subtitle: "Handmade pieces, each one unique.",
      view: "View",
      add: "Add to cart",
      added: "Added to cart",
      stock: "in stock",
      outOfStock: "Sold out",
    },
    product: {
      details: "Details",
      back: "← Back to the collection",
      quantity: "Quantity",
      noteLabel: "Additional info",
      handmade: "Handmade • fired in small batches",
      care: "Care: hand-wash recommended",
    },
    cart: {
      title: "Cart",
      empty: "Your cart is empty.",
      browse: "Browse the collection",
      subtotal: "Subtotal",
      shipping: "Shipping calculated at the next step.",
      checkout: "Proceed to checkout",
      remove: "Remove",
      each: "pcs",
    },
    payment: {
      success_title: "Thank you for your order",
      success_body: "A confirmation has been sent to your email. We'll process your order shortly.",
      cancel_title: "Payment cancelled",
      cancel_body: "Your order was not charged. You can return to the cart and try again.",
      continue: "Keep browsing",
      verifying: "Verifying payment…",
    },
    admin: {
      login: "Admin login",
      email: "Email",
      password: "Password",
      signIn: "Sign in",
      dashboard: "Admin",
      products: "Products",
      orders: "Orders",
      add_product: "Add product",
      edit: "Edit",
      delete: "Delete",
      save: "Save",
      cancel: "Cancel",
      logout: "Log out",
      name_fi: "Name (FI)",
      name_en: "Name (EN)",
      name_sv: "Name (SV)",
      desc_fi: "Description (FI)",
      desc_en: "Description (EN)",
      desc_sv: "Description (SV)",
      price: "Price (€)",
      image_url: "Image URL",
      stock: "Stock",
      featured: "Featured on home",
      confirm_delete: "Delete this product?",
    },
    footer: {
      studio: "Studio",
      contact: "Contact",
      address: "Atelier — Turku archipelago, Finland",
      rights: "All rights reserved.",
    },
    story: {
      title: "Hand, clay, fire.",
      body: "Every piece is made slowly. We use local clay and fire our kiln in small batches — so colors and surfaces vary, like in nature. You'll see the studio's fingerprints in every cup.",
    },
    showcase: {
      eyebrow: "From the collection",
      title: "Little hearts,\nquiet bunnies.",
      body: "Cups and sculptures that invite you close.",
    },
    instagram: {
      eyebrow: "On Instagram",
      title: "Follow @pikkurumiluksia",
      follow: "Follow on Instagram",
      empty: "No posts added yet.",
    },
  },
  sv: {
    nav: {
      home: "Hem",
      shop: "Butik",
      story: "Berättelse",
      cart: "Varukorg",
      admin: "Admin",
    },
    hero: {
      eyebrow: "Handgjorda små skatter",
      title: "Små\nskatter,\nhandgjorda.",
      lede: "Keramiska små konstigheter formade med kärlek — var och en liten, egen och helt unik.",
      cta_shop: "Se kollektionen",
      cta_story: "Studioberättelse",
    },
    shop: {
      title: "Kollektion",
      subtitle: "Handgjorda stycken, alla unika.",
      view: "Visa",
      add: "Lägg i varukorg",
      added: "Tillagd i varukorgen",
      stock: "i lager",
      outOfStock: "Slutsåld",
    },
    product: {
      details: "Detaljer",
      back: "← Tillbaka till kollektionen",
      quantity: "Antal",
      noteLabel: "Tilläggsinformation",
      handmade: "Handgjord • bränd i små satser",
      care: "Skötsel: handtvätt rekommenderas",
    },
    cart: {
      title: "Varukorg",
      empty: "Din varukorg är tom.",
      browse: "Bläddra i kollektionen",
      subtotal: "Delsumma",
      shipping: "Frakt beräknas i nästa steg.",
      checkout: "Till kassan",
      remove: "Ta bort",
      each: "st",
    },
    payment: {
      success_title: "Tack för din beställning",
      success_body: "En bekräftelse har skickats till din e-post. Vi behandlar din beställning snart.",
      cancel_title: "Betalning avbruten",
      cancel_body: "Din beställning har inte debiterats. Du kan gå tillbaka till varukorgen och försöka igen.",
      continue: "Fortsätt bläddra",
      verifying: "Verifierar betalning…",
    },
    admin: {
      login: "Admin-inloggning",
      email: "E-post",
      password: "Lösenord",
      signIn: "Logga in",
      dashboard: "Admin",
      products: "Produkter",
      orders: "Beställningar",
      add_product: "Lägg till produkt",
      edit: "Redigera",
      delete: "Ta bort",
      save: "Spara",
      cancel: "Avbryt",
      logout: "Logga ut",
      name_fi: "Namn (FI)",
      name_en: "Namn (EN)",
      name_sv: "Namn (SV)",
      desc_fi: "Beskrivning (FI)",
      desc_en: "Beskrivning (EN)",
      desc_sv: "Beskrivning (SV)",
      price: "Pris (€)",
      image_url: "Bild-URL",
      stock: "Lager",
      featured: "Utvald på startsidan",
      confirm_delete: "Ta bort produkten?",
    },
    footer: {
      studio: "Studio",
      contact: "Kontakt",
      address: "Atelier — Åbo skärgård, Finland",
      rights: "Alla rättigheter förbehållna.",
    },
    story: {
      title: "Hand, lera, eld.",
      body: "Varje stycke skapas långsamt. Vi använder lokal lera och bränner ugnen i små satser — så färger och ytor varierar, som i naturen. Du ser studions fingeravtryck i varje kopp.",
    },
    showcase: {
      eyebrow: "Ur kollektionen",
      title: "Små hjärtan,\ntysta kaniner.",
      body: "Koppar och skulpturer som bjuder dig nära.",
    },
    instagram: {
      eyebrow: "På Instagram",
      title: "Följ @pikkurumiluksia",
      follow: "Följ på Instagram",
      empty: "Inga inlägg tillagda ännu.",
    },
  },
};
